import { logoutApi } from '@dealstack/frontend/shared/dataExchange/services/auth.service';
import { beginIntentionalSignOut } from '@dealstack/frontend/shared/mechanism/session/intentionalSignOut';
import { useTranslationAuth } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { logout } from '@dealstack/frontend/shared/mechanism/redux/reducers/user/user';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useDispatch } from 'react-redux';

export const useShowErrorToastAndLogout = () => {
	const tAuth = useTranslationAuth();
	const dispatch = useDispatch();

	return async () => {
		dispatch(logout());
		showToastV2({
			title: tAuth('permission.error'),
			state: 'error',
			redirecting: true,
		});
		// Deliberate on the app's part, so the 401 it provokes must not redirect.
		beginIntentionalSignOut();
		await logoutApi();
	};
};
